module.exports = __webpack_public_path__ + "media/images/top/mv-36e392ccf81d017f464e2f0379adc7f5.jpg";